<template>
  <v-footer class="font-weight-medium footer-wrapper" height="120px">
    <v-row>
      <v-col cols="6">
        <v-btn text color="#FFFFFF" @click="toContact">
          <v-icon color="#ffffff" class="icon">mdi-email</v-icon>お問い合わせ
        </v-btn>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="6">
        <v-btn text color="#FFFFFF" @click="toHP">
          <p class="footer-text">©︎2020 Innoqua, Inc.</p>
        </v-btn>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  name: "Footer",
  data: () => ({}),
  methods: {
    toContact() {
      window.open("mailto:info@innoqua.jp", null, "noopener");
    },
    toHP() {
      window.open("https://corp.innoqua.jp/", null, "noopener");
    },
  }
};
</script>

<style scoped>
.footer-wrapper {
  background-color: #000000;
}
.footer-text {
  color: #ffffff;
  text-align: left;
}
.button-text {
  color: #ffffff;
}
.icon {
  text-align: right;
}
</style>
